const settingsKeys = {
  allSettings: ['allSettings'] as const,
};

export default settingsKeys;
